module.exports = __webpack_public_path__ + "img/arrow-bottom.a1ddd32.png";